<template>
  <el-dialog
    title="退还原因"
    :visible.sync="visible"
    width="700px"
    :close-on-click-modal="false"
    @opened="onOpened"
    class="dialog-Individuation"
  >
    <div style="color:red;padding:5px 0">
      退还保证金将导致您无法参与竞价，是否确认退还保证金?
    </div>
    <el-form
      label-suffix=":"
      label-width="150px"
      :model="form"
      label-position="top"
      ref="form"
    >
      <el-form-item
        label="请填写退还保证金原因"
        prop="remark"
        :rules="[{ required: true, message: ' ', trigger: 'blur' }]"
      >
        <el-input
          v-model="form.remark"
          type="textarea"
          :rows="3"
          maxlength="300"
          show-word-limit
        ></el-input>
      </el-form-item>
    </el-form>

    <span slot="footer">
      <el-button @click="submit(1)" type="primary" :loading="loading"
        >提交</el-button
      >
      <el-button @click="onCancel" :loading="loading">取消</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'ReturnDepositDialog',
  props: {
    clickRow: Object,
    show: Boolean
  },
  components: {},
  data() {
    return {
      form: { remark: '' },
      loading: false
    }
  },
  computed: {
    visible: {
      get() {
        return this.show
      },
      set(v) {
        this.$emit('update:show', v)
      }
    }
  },

  methods: {
    async onOpened() {},

    async submit() {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.revokeDeposit()
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    async revokeDeposit() {
      let params = {
        id: this.clickRow.id,
        remark: this.form.remark
      }
      let data = await this.$api.depositPrice.revokeDeposit(params)
      console.log(data)
      if (data) {
        this.$message.success('提交成功')
        this.onCancel()
        this.$emit('success', false)
      }
    },
    onCancel() {
      this.$emit('update:show', false)
      this.form.remark = ''
    }
  }
}
</script>
<style lang="less" scoped></style>
